import { captureMiddlewareError } from './captureMiddlewareError'
import { captureMiddlewarePerformance } from './captureMiddlewarePerformance'
import { getMiddlewareHeaders } from './getMiddlewareHeaders'
import { getMiddlewareUrl } from './getMiddlewareUrl'
import { updateSession } from '../default/updateSession'
import { getSessionValue } from '../default/getSessionValue'

/**
 * Verifies an otp code
 * @param {string} code - The otp code
 * @param {string} phone - The phone associated with the code
 * @param {string} sessionId - The session ID
 * @returns {Promise<boolean>}
 */
export async function verifyCodeInternal(
  code,
  phone,
  sessionId = 'tdMainFunnel',
) {
  const apiBase = getMiddlewareUrl()
  const endpoint = '/api/otp/verify'
  const url = `${apiBase}${endpoint}`

  const startTime = performance.now()
  try {
    const funnel = getSessionValue(sessionId, 'funnel') || ''
    const affId = getSessionValue(sessionId, 'aff_id') || ''
    const utmCampaign = getSessionValue(sessionId, 'utm_campaign') || ''
    const trid = getSessionValue(sessionId, 'trid') || ''

    const body = JSON.stringify({
      code,
      phone,
      funnel,
      aff_id: utmCampaign || affId,
      trid,
    })
    const response = await fetch(url, {
      body,
      headers: getMiddlewareHeaders(),
      method: 'POST',
    })

    captureMiddlewarePerformance(url, performance.now() - startTime)

    if (response.ok) {
      const data = await response.json()
      if (data.lead) {
        updateSession(sessionId, 'firstName', data.lead.First_Name)
        updateSession(sessionId, 'lastName', data.lead.Last_Name)
        updateSession(sessionId, 'mainEmail', data.lead.Email)
      }
      const success = /** @type {boolean} */ (data.success)

      return success || false
    }

    return false
  } catch (error) {
    captureMiddlewarePerformance(url, performance.now() - startTime)
    captureMiddlewareError(url, /** @type {Error} */ (error))
    return false
  }
}
